import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import FlagNote from 'src/models/AP/FlagNote';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { useDispatch } from 'react-redux';
import actions from 'src/actions';
import DialogList from 'src/dialogs';
import '../css/ProjectBilling.css';

interface IViewFlagNotesDialogProps {
    dialogName: string;
    handleConfirm?: (reason: string) => void;
    hideDialog: () => void;
    label?: string;
    notes?: FlagNote[];
    setRelaunch?: (launch: boolean) => void;
    setNoteMode?: (mode: boolean) => void;
}

const ViewFlagNotesDialog = (props: IViewFlagNotesDialogProps) => {
    const dispatch = useDispatch();

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (!!props?.notes && props.notes?.length > 0) {
            console.log('wth!!');
        }
    }, [props.notes]);

    const onCreate = () => {
        console.log('DefineBudgetCategoryDialog onCreate()');
    };

    const formatDateTime = (date: Date = new Date()) => {
        return date
            .toLocaleString(undefined, {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit'
            })
            .replace(',', '');
    };

    const displayFlagAndCorrectionNotes = () => {
        return <div>
            <table className={'project-billing'}>
                <thead>
                    <tr>
                        <th style={{textAlign: 'center', width: '5%' }}>Owner</th>
                        <th style={{textAlign: 'center', width: '7%' }}>Created</th>
                        <th style={{textAlign: 'center', width: '7%' }}>Action</th>
                        <th style={{textAlign: 'center', width: '15%' }}>Note</th>
                    </tr>
                </thead>
                <tbody className={'project-billing'} style={{width: '100%', maxHeight: '30vh', overflowY: 'auto'}}>
                {props.notes?.length > 0 && props.notes?.map(
                    (n: FlagNote, index: number) => {
                    return (
                        <div key={n.billingId + index}>
                            <tr className={'project-billing table-item-hover'} style={{ textAlign: 'left' }}>
                                <td style={{verticalAlign: 'middle', width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}                                        
                                        name={`owner`}
                                        defaultVal={n?.owner}
                                        type="text"
                                        style={{ width: '100%', background: '#d5f7f5' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{verticalAlign: 'middle', width: '5%' }}>
                                    <RHFInputBox
                                        name={`date`}
                                        readOnly={true}
                                        defaultVal={n?.created ? formatDateTime(new Date(n?.created)) : ''}
                                        type="text"
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{verticalAlign: 'middle', width: '2%' }}>
                                    <RHFInputBox
                                        name={`noteType`}
                                        readOnly={true}
                                        defaultVal={n?.type === 'F' ? 'Flag' : 'Correction'}
                                        type="text"
                                        style={n?.type === 'F' ? {backgroundColor: 'red', width: '100%' } : {backgroundColor: 'rgba(204, 85, 0, 0.78)', width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%', padding: '0px', height: '100%' }}>
                                <div
                                    style={{
                                    height: '100%',
                                    minHeight: '100%',
                                    overflowY: 'auto',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word',
                                    lineHeight: '1.4rem',
                                    border: '1px solid #ccc',
                                    padding: '.75rem',
                                    backgroundColor: 'white',
                                    boxSizing: 'border-box',
                                    }}
                                >
                                    {n?.note}
                                </div>
                                    {/*<textarea
                                        id={'flagReasonDialogTextArea'}
                                        name={'flagReasonTextArea'}
                                        style={{width: '100%', maxHeight: '10rem', resize: 'none'}}
                                        value={n?.note}
                                    />*/}
                                </td>
                            </tr>
                        </div>
                    );
                })}
                
                </tbody>
            </table>
        </div>;
    };

    const showAddFlagOrCorrectionDialog = (mode: number) => {
        if (mode === 0) {
            props?.setNoteMode(false);
        } else {
            props?.setNoteMode(true);
        }
        props.setRelaunch(true);
        dispatch(actions.layout.showDialog(DialogList.FLAG_REASON_DIALOG));
        // alert(`Show the note entry dialog in the ${mode === 1 ? 'Correction' : 'Flag' } mode.`);
    };

    return (
        <Dialog title="Flag & Correction Notes" dialogName={props.dialogName} isExitButtonInvisible={false} bodyStyle={{ width: '50%' }}>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Add Correction'}
                    onClick={() => showAddFlagOrCorrectionDialog(1)}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Add Flag'}
                    onClick={() => showAddFlagOrCorrectionDialog(0)}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Close'}
                    onClick={() => props.hideDialog()}
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form
                >
                    {displayFlagAndCorrectionNotes()}
                </form>
            </div>
        </Dialog>
    );
};

export default ViewFlagNotesDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/ViewFlagNotesDialog.tsx